import _ from "lodash";
//-- Notifier -------------------------------------------------------------------------------------------------------------------------------
class ResizeHelper {
    constructor() {
        this._listeners = [];
        this.myEfficientFn = this.debounce(() => this.onResize, 1000, false);
        let debounced = this.debounce(() => this.onResize(), 250, false);
        window.addEventListener('resize', debounced, false);
        this._listeners = [];
    }
    debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
        };
    }
    onResize() {
        const theWindow = window;
        if (!theWindow || !this._listeners || this._listeners.length === 0)
            return;
        _.forEach(this._listeners, (listener) => listener.callback(theWindow.innerWidth, theWindow.innerHeight));
    }
    addListener(uuid, callback) {
        const theWindow = window;
        if (theWindow) {
            this._listeners.push({ uuid, callback });
        }
    }
    removeListener(uuid, callback) {
        const theWindow = window;
        if (theWindow) {
            _.remove(this._listeners, (item) => item.uuid === uuid);
        }
    }
    forceResize() {
        this.onResize();
    }
}
//-- Singleton Notifier exposed to the rest of the app -------------------------------------------------------------------------------------------------------------------------------
export var resizeHelper;
export function initialiseResizeHelper() {
    resizeHelper = new ResizeHelper();
}
